export default "__VITE_ASSET__Dj1zZ3q9__"